/* eslint-disable */
<template>
  <div class="div-container">
    <template v-if="isApplicationLoading">
      <div class="loadingProgress">
        <v-progress-circular
          class="primary--text"
          :style="{marginLeft: '2rem'}"
          indeterminate
        ></v-progress-circular>
      </div>
    </template>
    <template v-else>
      <!-- FORM & FILTERS -->
      <v-row class="plantillaChips">
        <v-col class="mobile-style" cols="12">
          <div :style="{marinLeft: '1rem'}">
            <p v-html="$t('views.configuration.applications.descripcionView')"></p>
          </div>

          <div class="ml-1_5">
            <div>
              <v-row class="class-row">
                <v-col class="icon-col">
                  <v-icon class="class-icon">icon-ayudadigital-appmovil</v-icon>
                </v-col>
                <v-col class="label-col">
                  <p>{{listaCanales[0].label}}</p>
                </v-col>
                <v-col class="switch-col">
                  <v-switch
                  :input-value="listaCanales[0].value"
                  :readonly="isReadonlyCanal(0)"
                  @click.prevent="handleCanalSwitch(0)"
                  :style="{width: 'fit-content !important'}"></v-switch>
                </v-col>
              </v-row>
              <v-row class="class-row">
                <v-col class="icon-col">
                  <v-icon class="class-icon">icon-ayudadigital-whatsapp</v-icon>
                </v-col>
                <v-col class="label-col">
                  <p>{{listaCanales[1].label}}</p>
                </v-col>
                <v-col class="switch-col">
                  <v-switch
                  :input-value="listaCanales[1].value"
                  :readonly="isReadonlyCanal(1)"
                  @click.prevent="handleCanalSwitch(1)"
                  :style="{width: 'fit-content !important'}"></v-switch>
                </v-col>
              </v-row>
              <v-row class="class-row">
                <v-col class="icon-col">
                  <v-icon class="class-icon">mdi-email-outline </v-icon>
                </v-col>
                <v-col class="label-col">
                  <p>{{listaCanales[2].label}}</p>
                </v-col>
                <v-col class="switch-col">
                  <v-switch
                  :input-value="listaCanales[2].value"
                  :readonly="isReadonlyCanal(2)"
                  @click.prevent="handleCanalSwitch(2)"
                  :style="{width: 'fit-content !important'}"></v-switch>
                </v-col>
              </v-row>
              <v-row class="class-row">
                <v-col class="icon-col">
                  <v-icon class="class-icon">mdi-message-reply-outline</v-icon>
                </v-col>
                <v-col class="label-col">
                  <p>{{listaCanales[3].label}}</p>
                </v-col>
                <v-col class="switch-col">
                  <v-switch
                  :input-value="listaCanales[3].value"
                  :readonly="isReadonlyCanal(3)"
                  @click.prevent="handleCanalSwitch(3)"
                  :style="{width: 'fit-content !important'}"></v-switch>
                </v-col>
              </v-row>
            </div>
          </div>

          <!-- TEXT -->
          <div class="mt-6">
            <p>{{ $t('views.configuration.applications.suscribeAreas') }}</p>
          </div>

          <!-- CHIP -->
          <v-sheet v-if="showFilters" class="showWeb mb-5 mt-1">
            <div class="container__chip">
              <v-menu
                v-for="group in groupingsAppList"
                :key="group.uuid"
                :close-on-content-click="false"
                @input="(val) => {
                  if (val) {
                    showSearchInput = false;
                    groupingsAppList.forEach(item => {
                      if (group.uuid != item.uuid) {
                        item.focus = false;
                        item.active = false;
                      }
                    });
                    groupUuidSelected = group.uuid;
                    group.focus = true;
                  }

                  if (!val && !group.active) {
                    showSearchInput = false;
                    groupingsAppList.forEach(group => {
                      if (group.uuid != groupUuidSelected) {
                        group.focus = false;
                        group.active = false;
                      }
                    });
                  }
                  }"
              >
                <template v-slot:activator="{ on, attrs }">
                  <span
                    v-bind="attrs"
                    v-on="on"
                    :class="[group.active || group.focus ?
                    'chip__active' : '', 'chip__agrupaciones chip__filter v-chip']"
                  >
                    <div class="chipMenu" style="display: flex;">
                      <div style="display: flex; font-size: 13px;">
                        <span>
                          {{ group.nombre }} ({{ group.subscribed }} de {{ group.total }})
                        </span>
                      </div>
                      <v-icon class="iconChips">
                        {{
                          findOptions({ nombre: group.nombre })
                            ? 'mdi-chevron-up'
                            : 'mdi-chevron-down'
                        }}
                      </v-icon>
                    </div>
                  </span>
                </template>

                <v-list class="listSheet">
                  <v-list-item
                    :key="`suscribir${group.uuid}`"
                    link
                    class="listSheetItem"
                    @click="clickAddGroup({
                      groupId: group.uuid,
                      nombre: group.nombre
                    })"
                  >
                    <v-list-item-title class="listSheetTitle">Suscribir</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item
                    :key="`desuscribir${group.uuid}`"
                    link
                    class="listSheetItem"
                    @click="clickDeleteGroup({
                      groupId: group.uuid,
                      nombre: group.nombre
                    })"
                  >
                    <v-list-item-title class="listSheetTitle">Desuscribir</v-list-item-title>
                  </v-list-item>

                  <v-divider></v-divider>

                  <v-list-item
                    :key="`MasDetalle${group.uuid}`"
                    link
                    class="listSheetItem"
                    @click="clickFilterGroup({ name: group.nombre })"
                  >
                    <v-list-item-title class="listSheetTitle">Más detalle</v-list-item-title>
                  </v-list-item>
                </v-list>
              </v-menu>
            </div>
          </v-sheet>

          <v-sheet v-if="showFilters" class="showMobile mobile-style">
            <v-slide-group
                multiple
                show-arrows
              >
                <v-slide-item>
                  <div class="container__chip">
                    <v-menu
                  v-for="group in groupingsAppList"
                  :key="group.uuid"
                  :close-on-content-click="false"
                  @input="(val) => {
                    if (val) {
                      showSearchInput = false;
                      groupingsAppList.forEach(group => {
                        group.focus = false;
                        group.active = false;
                      });
                      groupUuidSelected = group.uuid;
                      group.focus = !group.focus;
                    }

                    if (!val && !group.active) {
                      showSearchInput = false;
                      groupingsAppList.forEach(group => {
                        if (group.uuid != groupUuidSelected) {
                          group.focus = false;
                          group.active = false;
                        }
                      });
                    }
                    }"
                >
                  <template v-slot:activator="{ on, attrs }">
                    <span
                      v-bind="attrs"
                      v-on="on"
                      :class="[group.active || group.focus ?
                      'chip__active' : '', 'chip__agrupaciones chip__filter v-chip']"
                    >
                      <div class="chipMenu" style="display: flex;">
                        <div style="display: flex">
                          <span>
                            {{ group.nombre }} ({{ group.subscribed }} de {{ group.total }})
                          </span>
                        </div>
                        <v-icon class="iconChips">
                          {{
                            findOptions({ nombre: group.nombre })
                              ? 'mdi-chevron-up'
                              : 'mdi-chevron-down'
                          }}
                        </v-icon>
                      </div>
                    </span>
                  </template>

                  <v-list class="listSheet">
                    <v-list-item
                      :key="`suscribir${group.uuid}`"
                      link
                      class="listSheetItem"
                      @click="clickAddGroup({
                        groupId: group.uuid,
                        nombre: group.nombre
                      })"
                    >
                      <v-list-item-title class="listSheetTitle">Suscribir</v-list-item-title>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item
                      :key="`desuscribir${group.uuid}`"
                      link
                      class="listSheetItem"
                      @click="clickDeleteGroup({
                        groupId: group.uuid,
                        nombre: group.nombre
                      })"
                    >
                      <v-list-item-title class="listSheetTitle">Desuscribir</v-list-item-title>
                    </v-list-item>

                    <v-divider></v-divider>

                    <v-list-item
                      :key="`MasDetalle${group.uuid}`"
                      link
                      class="listSheetItem"
                      @click="clickFilterGroup({ name: group.nombre })"
                    >
                      <v-list-item-title class="listSheetTitle">Más detalle</v-list-item-title>
                    </v-list-item>
                  </v-list>
                </v-menu>
                </div>
                </v-slide-item>
            </v-slide-group>
          </v-sheet>

          <!-- SEARCH -->
          <v-col v-if="showSearchInput" class="mobile-style" cols="12">
            <div class="container_form mobile-style">
              <v-text-field
                class="inputSearch"
                label="Aplicación"
                prepend-icon="mdi-magnify"
                v-model="textInput"
                @keyup="changeInput"
              >
              </v-text-field>
            </div>
          </v-col>
        </v-col>
      </v-row>

      <!-- CARD -->
      <template>
        <div>
          <!-- ERROR -->
          <v-row v-if="errorSuscripciones">
            <v-col cols="12">
              <p
                class="msgErrorSuscripciones">
                {{ msgErrorSuscripciones }}
              </p>
            </v-col>
          </v-row>

          <!-- LOADING -->
          <div v-if="loadingSubscriptions" class="loadingProgress">
            <v-progress-circular
              class="primary--text"
              :style="{marginLeft: '2rem'}"
              indeterminate
            ></v-progress-circular>
          </div>

          <!-- CARD SUSCRIPCIONES -->
          <div v-if="!loadingSubscriptions" class="d-flex flex-wrap">
            <template>
                <template v-for="group in groupingsAppList">
                  <template v-if="group.active">
                    <template v-for="application in group.children">
                      <v-card
                        :key="application.uuid"
                        class="mx-5 mb-5 card__aplicacion d-flex card justify-space-between"
                        max-width="420"
                      >
                        <v-card-title class="cardTitle">{{ application.nombre }}</v-card-title>
                        <v-card-actions>
                          <v-switch
                            v-model="application.suscrito"
                            @click="clickSwitchActivateApplication({
                              groupId: application.agrupacion.uuid,
                              nombre: application.nombre,
                              applicationId: application.uuid,
                              isSubscriber: application.suscrito,
                            })"
                          ></v-switch>
                        </v-card-actions>
                      </v-card>
                    </template>
                  </template>
                </template>
            </template>
          </div>
        </div>
      </template>
    </template>
  </div>
</template>

<script>

export default {
  data() {
    return {
      isBadge: false,
      isSubscription: true,
      loading: false,
      isApplicationLoading: true,
      showFilters: false,
      loadingSubscriptions: true,
      errorSuscripciones: false,
      name: '',
      textInput: '',
      msgErrorSuscripciones: '',
      titleAllGroups: 'Todo',
      showMenuGroup: null,
      groupingsAppList: [],
      groupingsAppListAux: [],
      applicationsAppList: [],
      stringSubscriptions: 'Todo',
      showMenuOptions: [],
      showSearchInput: false,
      dataLabel: false,
      filtersInitialMySubscription: [],
      filtersMySubscription: [],
      listaCanales: [
        {
          id: 'firebase',
          label: 'App ayudaDIGITAL',
          value: false,
        },
        {
          id: 'whatsapp',
          label: 'WhatsApp',
          value: false,
        },
        {
          id: 'email',
          label: 'Correo electrónico',
          value: false,
        },
        {
          id: 'sms',
          label: 'SMS',
          value: false,
        },
        {
          id: 'silencio',
          label: 'Pausar',
          value: false,
        },
      ],
      isLoadingPutPreferencias: false,
      isLinkBanner: false,
      groupUuidSelected: false,
      typeBussiness: [],
      typeBussinessPreferences: [],
    };
  },
  props: {
    applications: {
      type: Array,
      default: () => [],
    },
  },
  methods: {
    isReadonlyCanal(index) {
      // console.log('filtersInitialMySubscription',
      // this.filtersInitialMySubscription[0].subscribed);

      const primerosCanales = this.listaCanales.slice(0, 4);
      const activos = primerosCanales.filter((canal) => canal.value === true).length;
      const aplicacionesTotales = this.filtersInitialMySubscription[0]
      && this.filtersInitialMySubscription[0].subscribed >= 1;
      return activos === 1 && primerosCanales[index].value === true && aplicacionesTotales;
    },
    handleCanalSwitch(index) {
      // if (this.isReadonlyCanal(index)) {
      //   this.$store.dispatch('messages/createNotificationMessage', {
      //     type: 'warning',
      //     icon: 'mdi-alert',
      //     title: this.$t('views.configuration.applications.atLeastOneChannel'),
      //     timeout: this.$getConst('notifications.timeout'),
      //   });
      //   return;
      // }

      const newValue = !this.listaCanales[index].value;
      // const isTurningOff = newValue === false;
      // const hasAnotherActive = this.listaCanales
      //   .slice(0, 4)
      //   .some((canal, canalIndex) => canalIndex !== index && canal.value === true);
      // const aplicacionesTotales = this.filtersInitialMySubscription[0]
      // && this.filtersInitialMySubscription[0].subscribed >= 1;

      // if (isTurningOff && !hasAnotherActive && aplicacionesTotales) {
      //   this.$store.dispatch('messages/createNotificationMessage', {
      //     type: 'warning',
      //     icon: 'mdi-alert',
      //     title: this.$t('views.configuration.applications.atLeastOneChannel'),
      //     timeout: this.$getConst('notifications.timeout'),
      //   });
      //   return;
      // }

      this.$set(this.listaCanales, index, {
        ...this.listaCanales[index],
        value: newValue,
      });

      this.putPreferencias();
    },
    async putPreferencias() {
      this.isLoadingPutPreferencias = true;

      const canaleFijos = this.typeBussiness;

      // const canaleFijos = [
      //   this.$getConst('tipoNegocio.paradaPlanificada'),
      //   this.$getConst('tipoNegocio.incidenciaImpacto'),
      // ];

      const messageId = await this.$store.dispatch(
        'messages/createNotificationMessage',
        {
          icon: 'progress-circular',
          title: this.$t('ticketActions.messages.creating'),
        },
      );
      const { id, userid } = this.$store.getters['session/user'];

      try {
        const canalesCompletos = [];

        this.typeBussinessPreferences.forEach((preferencia) => {
          let canalesActivos = [];
          if (canaleFijos.includes(preferencia.tipoNegocio.id)) {
            canalesActivos = this.listaCanales.filter((canal) => canal.value === true)
              .flatMap((canal) => this.$getConst(`canales.${canal.id}.modo`));

            const aux = {
              tipoNegocio: preferencia.tipoNegocio.id,
              canales: canalesActivos,
            };
            canalesCompletos.push(aux);
          } else {
            canalesActivos = preferencia.canales.map((canal) => canal.modo);
            const aux = {
              tipoNegocio: preferencia.tipoNegocio.id,
              canales: canalesActivos,
            };
            canalesCompletos.push(aux);
          }
        });

        const response = await this.$api.getClient('suscripciones').putCanalesPreferencias({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: `gestnotif/suscriptores/${id}/preferencias`,
          },
          body: {
            organizacion: 'CA',
            preferencias: canalesCompletos,
          },
        });

        if (response) {
          this.isLoadingPutPreferencias = false;
        }

        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'success',
          icon: 'mdi-check-circle',
          title: this.$t('ticketActions.messages.success'),
          timeout: this.$getConst('notifications.timeout'),
        });
      } catch (error) {
        // console.log(error);
        this.$store.dispatch('messages/updateMessage', {
          id: messageId,
          type: 'error',
          icon: 'mdi-close-circle',
          title: this.$t('ticketActions.messages.error'),
          timeout: this.$getConst('notifications.timeout'),
        });
      }
    },
    handleClickOutside() {
      const buttons = document.querySelectorAll('button.v-icon');
      buttons.forEach((button) => {
        button.classList.remove('mdi-chevron-up');
        button.classList.add('mdi-chevron-down');
      });
      this.showMenuGroup = null;
    },
    showOptions({ nombre }) {
      this.clickFilterGroup({ name: nombre });
      this.showMenuGroup = nombre;
    },
    findOptions({ nombre }) {
      return nombre === this.showMenuGroup;
    },
    changeInput(e) {
      this.filtersMySubscription = [];

      const applicationName = e.target.value;
      // console.log('changeInput', e.target.value);
      this.groupingsAppList = this.groupingsAppListAux;

      if (applicationName !== '') {
        this.groupingsAppList = this.groupingsAppList.map((group, index) => {
          const filteredChildren = applicationName
            ? group.children.filter((child) => child.nombre
              .toLowerCase()
              .includes(applicationName.toLowerCase()))
            : group.children;
          const isActive = index === 0;

          return {
            ...group,
            active: isActive,
            children: filteredChildren,
          };
        });
      }
    },
    clickFilterGroup({ name }) {
      this.filtersMySubscription = [];
      this.textInput = '';
      this.changeInput({ target: { value: '' } });
      this.groupingsAppList = this.groupingsAppListAux;
      this.groupingsAppList.forEach((group) => {
        group.active = group.nombre === name; // eslint-disable-line
      });

      this.filtersMySubscription.push(name);
      this.showSearchInput = true;
    },
    filterSearch(data) {
      const { text } = data;
      this.clickFilterGroup({ name: text });
    },
    //
    async addSubscriptionsAll() {
      this.loadingSubscriptions = true;
      const { id, userid } = this.$store.getters['session/user'];

      try {
        const response = await this.suscripcionesClient.addSubscriptionsAll({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones/aplicaciones',
          },
        });

        if (response.status && response.status === 200) {
          this.groupingsAppList.forEach((group) => {
            group.children.forEach((application) => {
              application.suscrito = true; // eslint-disable-line
            });
          });

          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
          this.sortApplicationsBySubscription();
        }
      } catch (error) {
        // console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    async deleteSubscriptionsAll() {
      this.loadingSubscriptions = true;
      const { id, userid } = this.$store.getters['session/user'];

      try {
        const response = await this.suscripcionesClient.deleteSubscriptionsAll({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones/aplicaciones',
          },
        });

        if (response.status && response.status === 200) {
          this.groupingsAppList.forEach((group) => {
            group.children.forEach((application) => {
              application.suscrito = false; // eslint-disable-line
            });
          });

          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
          this.sortApplicationsBySubscription();
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    //
    clickAddGroup({ groupId, nombre }) {
      this.groupingsAppList.find((group) => group.uuid === groupId).active = true;
      this.showSearchInput = true;
      if (nombre === this.titleAllGroups) {
        this.addSubscriptionsAll();
      } else {
        this.addApplicationOrGroups({ uuidAgrupacion: groupId, nombre });
      }
    },
    clickDeleteGroup({ groupId, nombre }) {
      this.groupingsAppList.find((group) => group.uuid === groupId).active = true;
      this.showSearchInput = true;
      if (nombre === this.titleAllGroups) {
        this.deleteSubscriptionsAll();
      } else {
        this.deleteApplicationOrGroups({ uuidAgrupacion: groupId, nombre });
      }
    },
    clickSwitchActivateApplication({
      groupId,
      applicationId,
      nombre,
      isSubscriber,
    }) {
      if (!isSubscriber) {
        this.deleteApplicationOrGroups({
          uuidAgrupacion: groupId,
          uuidAplicacion: applicationId,
          nombre,
        });
      } else {
        this.addApplicationOrGroups({
          uuidAgrupacion: groupId,
          uuidAplicacion: applicationId,
          nombre,
        });
      }
    },
    //
    async deleteApplicationOrGroups({ uuidAgrupacion, uuidAplicacion, nombre }) {
      const { id, userid } = this.$store.getters['session/user'];
      const status = false;

      // Si no viene el uuidAplicacion la accion ha sido por agrupacion
      if (!uuidAplicacion) {
        this.loadingSubscriptions = true;
      }

      try {
        const response = await this.suscripcionesClient.deleteApplications({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/suscripciones/agrupaciones',
          },
          uuidAgrupacion,
          uuidAplicacion,
        });

        if (response.status === 200) {
          if (!uuidAplicacion) {
            this.updateStatusGroups({
              uuidAgrupacion,
              nombre,
              status,
            });
          } else {
            this.updateStatusApplication({
              uuidAgrupacion,
              uuidAplicacion,
              nombre,
              status,
            });
          }
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        this.loadingSubscriptions = false;
      }
    },
    async addApplicationOrGroups({ uuidAgrupacion, uuidAplicacion, nombre }) {
      const { id, userid } = this.$store.getters['session/user'];
      const status = true;

      // Si no viene el uuidAplicacion la accion ha sido por agrupacion
      if (!uuidAplicacion) {
        this.loadingSubscriptions = true;
      }

      try {
        const response = await this.suscripcionesClient.addApplications({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/suscripciones/agrupaciones',
          },
          uuidAgrupacion,
          uuidAplicacion,
        });

        if (response.status === 200) {
          if (!uuidAplicacion) {
            this.updateStatusGroups({
              uuidAgrupacion,
              nombre,
              status,
            });
          } else {
            this.updateStatusApplication({
              uuidAgrupacion,
              uuidAplicacion,
              nombre,
              status,
            });
          }
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgOKAgrupaciones'),
            icon: 'mdi-check',
            type: 'success',
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        } else {
          this.$store.dispatch('messages/createNotificationMessage', {
            title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
            type: 'error',
            dismissible: true,
            timeout: this.$getConst('notifications.timeoutPlus'),
          });
        }
      } catch (error) {
        console.log(error);
        this.$store.dispatch('messages/createNotificationMessage', {
          title: this.$t('views.mySubscriptions.view.msgKOAgrupaciones'),
          type: 'error',
          dismissible: true,
          timeout: this.$getConst('notifications.timeoutPlus'),
        });
      } finally {
        if (this.isLinkBanner) {
          this.loadingSubscriptions = true;
        } else {
          this.loadingSubscriptions = false;
        }
      }
    },
    //
    async getApplications() {
      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscripcionesClient.getApplications({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones/aplicaciones',
          },
        });

        const { collection_subscriptions: collectionSubscriptions } = response;
        return collectionSubscriptions;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    async getGroups() {
      try {
        const { id, userid } = this.$store.getters['session/user'];
        const response = await this.suscripcionesClient.getGroups({
          apiCges: {
            delegado: userid,
            uuidSuscriptor: id,
            endpoint: 'cges/notif/agrupaciones',
          },
        });

        const { collection_subscriptions: collectionSubscriptions } = response;
        return collectionSubscriptions;
      } catch (error) {
        console.log(error);
      }
      return null;
    },
    //
    updateStatusApplication({
      uuidAgrupacion,
      uuidAplicacion,
      nombre,
      status,
    }) {
      this.groupingsAppList.forEach((group) => {
        if (group.nombre === this.titleAllGroups) {
          group.children.forEach((application) => {
            if (
              application.agrupacion.uuid === uuidAgrupacion
              && application.uuid === uuidAplicacion
            ) {
              application.suscrito = status; // eslint-disable-line
            }
          });
        } else {
          group.children.forEach((application) => {
            if (
              application.agrupacion.uuid === uuidAgrupacion
              && application.uuid === uuidAplicacion
              && application.nombre === nombre
            ) {
              application.suscrito = status; // eslint-disable-line
            }
          });
        }
      });
      this.sortApplicationsBySubscription();
    },
    updateStatusGroups({
      uuidAgrupacion,
      status,
    }) {
      this.groupingsAppList = this.groupingsAppList.map((group) => {
        group.children = group.children.map((child) => { // eslint-disable-line
          if (child.agrupacion.uuid === uuidAgrupacion) {
            return {
              ...child,
              suscrito: status,
            };
          }
          return child;
        });
        return group;
      });

      this.sortApplicationsBySubscription();
    },
    sortApplicationsBySubscription() {
      this.groupingsAppList.forEach((group) => {
        group.subscribed = group.children.filter((item) => item.suscrito).length; // eslint-disable-line
        const listaActualizada = this.filtersInitialMySubscription.map((item) => {
          if (item.text === group.nombre) {
            return { ...item, subscribed: group.subscribed };
          }
          return item;
        });
        this.filtersInitialMySubscription = listaActualizada;
        group.children.sort((a, b) => b.suscrito - a.suscrito);
      });

      this.groupingsAppListAux = this.groupingsAppList;
    },
    async getPreferencias() {
      const { id, userid } = this.$store.getters['session/user'];
      const paradaPanificada = this.$getConst('tipoNegocio.paradaPlanificada');
      // const incidenciaImpacto = this.$getConst('tipoNegocio.incidenciaImpacto');

      const preferencias = await this.$api.getClient('suscripciones').getCanalesPreferencias({
        apiCges: {
          delegado: userid,
          uuidSuscriptor: id,
          endpoint: `gestnotif/suscriptores/${id}/preferencias`,
        },
      });

      if (preferencias && preferencias.length > 0) {
        this.typeBussinessPreferences = preferencias;
        const { canales } = preferencias.find((preferencia) => preferencia.tipoNegocio.id === paradaPanificada); // eslint-disable-line

        if (canales.length > 0) {
          // console.log('****getPreferencias', { canales, preferencias });
          canales.forEach((canal) => this.actualizaCanal(canal.modo, true));
        }
      }
    },
    actualizaCanal(id, value) {
      const index = this.listaCanales.findIndex((canal) => canal.id === id);

      if (index !== -1) {
        this.listaCanales[index].value = value;
      }
    },
    isUserTic() {
      const user = this.$store.getters['session/user'];
      return user.accessTypeTic;
    },
    goToProfile() {
      this.$router.push('/profile/edit');
    },
    getDataForSubscriptions({ applications, groupingsAppList }) {
      const resultado = [];

      groupingsAppList.children.forEach((child) => {
        if (applications.includes(child.uuid)) {
          const {
            nombre,
            uuid,
            suscrito,
            agrupacion,
          } = child;

          resultado.push({
            nameGroup: agrupacion.nombre,
            uuidGroup: agrupacion.uuid,
            nameAplication: nombre,
            uuidAplication: uuid,
            suscrito,
          });
        }
      });

      return resultado;
    },
    async suscriptionsApplications(applicationForsuscribir) {
      const promises = applicationForsuscribir.map((application) => {
        const {
          uuidGroup,
          nameAplication,
          uuidAplication,
          suscrito,
        } = application;

        if (!suscrito) {
          return this.addApplicationOrGroups({
            uuidAgrupacion: uuidGroup,
            uuidAplicacion: uuidAplication,
            nombre: nameAplication,
          });
        }

        return Promise.resolve();
      });

      await Promise.all(promises);
    },
  },
  async created() {
    this.suscripcionesClient = this.$api.getClient('suscripciones');
    // Sustituir por el numero de negocio que corresponda -->
    this.typeBussiness = await this.$api.getClient('suscripciones').getTiposNegocio(373);
    try {
      const [listApplicationsResponse, listGroupsResponse] = await Promise.all([
        this.getApplications(),
        this.getGroups(),
        this.getPreferencias(),
      ]);

      if (!listApplicationsResponse || !listGroupsResponse) {
        this.loadingSubscriptions = false;
        this.isApplicationLoading = false;
        console.error('Error fetching data from services');
        return;
      }

      const { applications: applicationsList } = listApplicationsResponse;
      const { groups: gropusList } = listGroupsResponse;

      const result = [];
      result.push({
        active: false,
        focus: false,
        children: applicationsList,
        nombre: this.titleAllGroups,
        uuid: null,
        total: applicationsList.length,
      });

      gropusList.forEach((group) => {
        const children = applicationsList.filter((app) => app.agrupacion.uuid === group.uuid);
        const subscribed = children.filter((item) => item.suscrito).length;
        const { nombre, uuid } = group;
        result.push({
          active: false,
          focus: false,
          children,
          nombre,
          uuid,
          total: children.length,
          subscribed,
        });
      });

      this.groupingsAppList = result;
      this.sortApplicationsBySubscription();

      this.filtersInitialMySubscription = this.groupingsAppList.map((item) => ({
        text: item.nombre,
        status: item.nombre,
        statusTrim: item.nombre.trim().replace(/\s+/g, ' '),
        groupId: item.uuid,
        total: item.total,
        subscribed: item.subscribed,
      }));

      if (this.applications && this.applications.length > 0) {
        this.isLinkBanner = true;
        const applicationsForSuyscription = this.getDataForSubscriptions({
          applications: this.applications,
          groupingsAppList: this.groupingsAppList[0],
        });

        await this.suscriptionsApplications(applicationsForSuyscription);
      }

      this.isLinkBanner = false;
      this.loadingSubscriptions = false;
      this.isApplicationLoading = false;
    } catch (error) {
      console.error('Error creating groupings:', error);
      this.loadingSubscriptions = false;
      this.isApplicationLoading = false;
    }
  },
  mounted() {
    document.addEventListener('click', this.handleClickOutside);
    setInterval(() => {
      this.showFilters = true;
    }, 1000);
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleClickOutside);
  },
};
</script>

<style lang="scss" scoped>
$header-padding: 10 0;

  .div-container {
    padding: 2rem;
  }
  .mdi-email-outline:before {
    color: #27846d !important;
  }

  .icon-ayudadigital-appmovil:before {
    color: #27846d !important;
  }
  .icon-ayudadigital-whatsapp:before {
    color: #27846d !important;
  }
  .mdi-message-reply-outline:before {
    color: #27846d !important;
  }

.v-menu__content{
    margin-top:2.5rem;
    box-shadow: none !important;
}
.listSheet{
    box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
     0px 8px 10px 1px rgba(0, 0, 0, 0.14),
     0px 3px 14px 2px rgba(0, 0, 0, 0.12) !important;
    display: grid;
    border: 1px green solid;
    border-radius: 0.4rem;
    padding: 0px !important;
}
.listSheetItem{
    display: block;
    min-height: 1rem;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
}
.loadingProgress{
    height: 10rem !important;
    display: inline-flex !important;
    align-items: center !important;
    justify-content: center !important;
    width: 100% !important;
}
.notification--title {
    font-size: 1rem;
  }
  .textEllipsis {
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
  }
  .selectCol {
    padding: 0;
  }
  .plantillaTree {
    background-color: white;
  }

  .plantillaSuscrip {
    background-color: white;
    /* padding: 1em 0em; */
    margin-bottom: 1em;
    margin-top: 1em;
    box-shadow: 0px 3px 1px -2px rgb(0 0 0 / 7%),
    0px 2px 2px 0px rgb(0 0 0 / 5%), 0px 1px 5px 0px rgb(0 0 0 / 5%);
  }

  .v-slide-group__next,
  .v-slide-group__prev {
    min-width: initial !important;
  }

  .misSuscripciones {
    color: #27846d !important;
    caret-color: #27846d !important;
    background-color: #e1f2ee !important;
  }

  .sinEstilosMisSuscripciones {
    color: #000000 !important;
    background-color: #e0e0e0 !important;
  }

  .card {
    flex: 0 0 33.3333%;
  }
  .plantillaChips {
    background: transparent;
  }

  .container-apps {
    display: flex;
    flex-wrap: wrap;
    justify-content: space-evenly;
  }
  .v-item-group .v-slide-group__wrapper .v-slide-group__content {
    display: flex!important;
    flex-wrap: wrap!important;
    width: 100%!important;
  }
  .container_form {
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-wrap: wrap;
    padding: 0 1rem;
  }

  .v-input__slot {
    width: fit-content !important;
  }

  .rounded-checkbox .v-input--selection {
  border-radius: 50% !important;
}

.rounded-checkbox .v-icon {
  font-size: 18px !important;
}
  .btn__suscripciones {
    margin-left: 2rem;
  }

  .chip__filter {
    padding: 0;
    padding-left: 15px;
    margin: 0.3rem;
    cursor: pointer;
    background: #e0e0e0;
    border-radius: 16px;
    font-size: 14px;
    height: 2rem;
    border-color: rgba(0, 0, 0, 0.12);
    color: rgba(0, 0, 0, 0.87);
  }

  .card__aplicacion {
    width: 100%;
  }
  .v-card__title{
    white-space: initial!important;
    word-break: inherit;
  }
  .msgErrorSuscripciones {
    margin-left: 1.5rem;
  }
  .chip__active {
    color: #27846d !important;
    background-color: #e6f1ee;
    border: 1px solid #27846d !important;
  }
  .description {
    padding: 0;
    margin: 0 2rem;
  }
  .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  .cardTitle {
    // align-items: center;
    // display: flex;
    // flex-wrap: wrap;
    font-size: 1rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
    line-height: initial !important;
    //word-break: none !important;
  }
  .iconChips{
  color:#27846d !important;
  }

  .v-expansion-panel-header {
    display: flex !important;
    justify-content: space-between !important;
  }
  .v-expansion-panel-header__icon {
      margin-left: 0 !important;
  }

  .col_canales {
    min-width: none !important;
    width: fit-content !important;
    height: fit-content !important;
    display: flex !important;
    flex-direction: column !important;
    align-items: center !important;
  }

  .row_canales__bg {
    background: #F0F0F0
  }

  .canal-p {
    margin: 0 !important;
  }

  .container_canales {
    width: 600px;
  }

  .div_canal_label {
    display: flex;
    flex-direction: column;
    color: #27846d;
    font-weight: 500;
  }

  .div_canal_label_disabled {
    color: gray;
    font-weight: 500;
  }

  .canal-icono {
    display: none;
  }

  .btn-guardar {
    width: 103.59px;
  }

  .canal_input_box {
    margin-left: 1.8rem;
    margin-top: 1rem;
    margin-bottom: 1rem;
    padding-left: 25rem;
  }

  .class-row {
    height: 40px;
  }

  .icon-col{
    max-width: 50px !important;
  }

  .label-col {
    max-width: 200px !important;
  }

  .switch-col {
    max-width: 65px !important;
  }

  .ml-1_5 {
    margin-left: 1.5rem;
  }

  .showMobile {
    display: none !important;
  }

  @media (max-width: 900px) {
    .showMobile {
      display: flex !important;
    }

    .mobile-style {
      padding-left: 0;
      padding-right: 0;
    }

    .canal_input_box {
      margin-left: 0;
      margin-top: 1rem;
      margin-bottom: 1rem;
      padding-left: 0;
    }
    .container_canales {
      width: 100%;
    }
    .canal-icono {
      display: flex;
    }
    .btn-guardar {
      width: auto;
    }
    .canal-p {
      margin: 0 !important;
      display: none;
    }
    .facet_sidebar {
      display: none;
    }
    .card.v-card {
      flex: initial;
    }
    .v-card__title {
      padding: 1rem 1rem!important;
      font-size: .8rem !important;
    }
    .v-card__actions {
      height: 50px!important;
      padding: 1rem 1rem!important;
      align-items: initial!important;
    }
    .chip__test > .v-slide-group__wrapper{
      background-color: red !important;
    }
    .cardTitle {
    // align-items: center;
    // display: flex;
    // flex-wrap: wrap;
    font-size: .8rem !important;
    font-weight: 400 !important;
    letter-spacing: 0 !important;
    line-height: initial !important;
    //word-break: none !important;
  }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 600px) {
    .btn__suscripciones {
      margin-left: 0;
    }
    div.v-slide-group__content {
      flex-wrap: wrap !important;
      width: 100% !important;
      background-color: red;
    }
    .inputSearch{
        margin-top: 0px !important;
        padding-top: 0px !important;
    }
  }
  @media (max-width: 768px) {
    .titleMobile{
      margin-left: 0rem !important;
    }
  }

</style>
